import { Button, Center, Group, Stack, Text, Title } from '@mantine/core';
import { CountrySelect } from '../../../shared/components/Inputs/CountrySelect';
import { SurveyResponse } from '../../../shared/types/SurveyResponse';
import { SurveyModel } from 'survey-core';
import { Survey } from 'survey-react-ui';
import { useTranslation } from 'react-i18next';
import { Survey as SurveyType } from '../../../shared/types/Survey';
import { Link } from 'react-router-dom';

type SurveyResponseComponentProps = {
  surveyResponse?: SurveyResponse;
  surveyModel: SurveyModel;
  survey: SurveyType;
  value: string | undefined;
  onChange: (value: string | null) => void;
  error: string | undefined;
  isLoading?: boolean;
  isCompleted?: boolean;
  onSave: () => void;
  showConfirmationModal?: () => void;
  canSubmit?: boolean;
  defaultCountry?: string;
};

export const SurveyResponseComponent = ({
  surveyModel,
  survey,
  value,
  onChange,
  error,
  isLoading,
  isCompleted,
  onSave,
  showConfirmationModal,
  canSubmit = false,
  defaultCountry,
}: SurveyResponseComponentProps) => {
  const { t } = useTranslation();

  return (
    <Center>
      <Stack w="100vw">
        <Stack
          w="100vw"
          maw={'calc(90*(var(--sjs-base-unit, var(--base-unit, 8px))))'}
          mx={'auto'}
        >
          <Title ta="center" order={1} size="h2">
            {survey.name}
          </Title>
          <Text fs={'italic'}>{t('documents.create.info')}</Text>
          <CountrySelect
            value={value}
            onChange={onChange}
            error={error}
            defaultValue={defaultCountry || undefined}
          />
          <Survey model={surveyModel} />
        </Stack>
        <Group justify="flex-end" p="md">
          <Button
            variant="outline"
            w="175px"
            component={Link}
            to={'/map/documents?pan=1'}
          >
            {t('common.cancel')}
          </Button>
          <Button
            variant="outline"
            w="175px"
            onClick={onSave}
            loading={isLoading}
            display={isCompleted ? 'none' : undefined}
          >
            {t('common.saveAndClose')}
          </Button>
          {canSubmit ? (
            <Button
              variant="outline"
              w="175px"
              loading={isLoading}
              onClick={showConfirmationModal}
              display={isCompleted ? 'none' : undefined}
            >
              {t('common.submit')}
            </Button>
          ) : null}
        </Group>
      </Stack>
    </Center>
  );
};
